import { render, staticRenderFns } from "./noticDialogActor.vue?vue&type=template&id=d6e8dcfc&scoped=true"
import script from "./noticDialogActor.vue?vue&type=script&lang=js"
export * from "./noticDialogActor.vue?vue&type=script&lang=js"
import style0 from "./noticDialogActor.vue?vue&type=style&index=0&id=d6e8dcfc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e8dcfc",
  null
  
)

export default component.exports